import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toHandlers as _toHandlers, mergeProps as _mergeProps, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/button-pager-prev.png'
import _imports_1 from '@/assets/icon/button-pager-next.png'


const _withScopeId = n => (_pushScopeId("data-v-ddf71b04"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "simple-pagination"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]

import { computed } from 'vue';

  export interface IProps {
    total: number;
    perPage: number;
    page: number;
    simple?: boolean;
  }
  export interface IEmits {
    (event: 'change', page: number): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    total: { default: 0 },
    perPage: null,
    page: { default: 1 },
    simple: { type: Boolean, default: false }
  },
  emits: ["change"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'change', page: number): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { total: number, perPage: number, page: number, simple: boolean }

  
  
  const on = {
    'update:modelValue'(e: number) {
      emits('change', e);
    }
  };

  const totalPage = computed(() => {
    if (props.perPage) {
      return Math.ceil(props.total / props.perPage);
    };
    return 0;
  });

  const handleNext = () => {
    emits('change', props.page + 1);
  };

  const handlePrev = () => {
    emits('change', props.page - 1);
  };


return (_ctx: any,_cache: any) => {
  const _component_b_pagination = _resolveComponent("b-pagination")!

  return (__props.simple)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["button button-left", { disabled: __props.page <= 1 }]),
          onClick: handlePrev
        }, _hoisted_3, 2),
        _createElementVNode("div", {
          class: _normalizeClass(["button button-right", { disabled: __props.page >= _unref(totalPage) }]),
          onClick: handleNext
        }, _hoisted_5, 2)
      ]))
    : (_openBlock(), _createBlock(_component_b_pagination, _mergeProps({
        key: 1,
        "per-page": __props.perPage,
        "total-rows": __props.total,
        "prev-text": "<",
        "next-text": ">",
        "first-number": "",
        "last-number": "",
        "model-value": __props.page
      }, _toHandlers(on)), null, 16, ["per-page", "total-rows", "model-value"]))
}
}

})